import { RotateCcw } from 'lucide-react';
import { fmt } from '@cca/ui';
import type { LineItem } from '../types';
import { TombstoneIcon } from './TombstoneIcon';

type Kind = 'income' | 'expense';

type Props = {
  row: LineItem;
  kind: Kind;
  onRestore: (kind: Kind, id: string) => void;
};

const formatArchivedAt = (iso: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-NZ', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  });
};

// Inline-revealed archived row. Shares the table column layout so columns
// align with active rows. No projections (archived rows don't contribute
// to totals); year columns show an em-dash.
export function ArchivedRow({ row, kind, onRestore }: Props) {
  return (
    <tr className="row-archived" title={`Archived ${formatArchivedAt(row.deletedAt)}`}>
      <td className="text-center">
        <TombstoneIcon className="w-3 h-3 inline text-ccaanz-gold opacity-70" />
      </td>
      <td className="no-print"></td>
      <td className="text-center line-no">—</td>
      <td>
        <span className="line-code">{row.code || '—'}</span>
      </td>
      <td className="col-name">
        <span className="line-name">{row.name}</span>
      </td>
      <td className="col-actual"></td>
      <td className="col-current text-right num">{fmt(row.currentAmount)}</td>
      <td className="col-shade text-right num text-ccaanz-grey">—</td>
      <td className="text-right num text-ccaanz-grey">—</td>
      <td className="col-shade text-right num text-ccaanz-grey">—</td>
      <td className="no-print">
        <div className="flex items-center justify-end">
          <button
            type="button"
            className="row-control"
            onClick={() => onRestore(kind, row.id)}
            title={`Restore — was archived ${formatArchivedAt(row.deletedAt)}`}
            aria-label="Restore line"
          >
            <RotateCcw className="w-4 h-4" />
          </button>
        </div>
      </td>
    </tr>
  );
}
